import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import TopPageButton from "../Components/TopPage/TopePage";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";
import MeetingForm from "../Components/Form/MeetingForm";

const Meetings = () => {
  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <>
      <Helmet>
        <title>Book Meeting | Aneeq Ullah Khan</title>
        <meta
          name="description"
          content="You can book meeting according to my services and any guidance you want from me this page is made for you."
        />
        <meta
          name="keywords"
          content="Aneeq, Aneeq Ullah Khan, Aneeq Ullah Khan Portfolio, Aneeq Khan, Aneeq Portfolio, Aneeq Resume, Aneeq CV, Aneeq Firebase, Aneeq Ullah Khan Fiverr, Aneeq Ullah Khan Linkedin, React, React Js, Aneeq Ullah Khan React Developer, Top Pakistan React Developer, Pakistan Developer, Top Pakistan Frontend Developer, Frontend Developer"
        />
      </Helmet>
      <Navbar />

      <div className="fixing">
        <div className="container text-center">
          <br />
          <div className="mt-5">
            <h3 className="fw-bolder">Book Your Meeting</h3>
            <p>Have a nice day.</p>
          </div>
        </div>
      </div>

      <MeetingForm />

      <Footer />
      <TopPageButton />
    </>
  );
};

export default Meetings;
